import { render, staticRenderFns } from "./ProgramTypeIndex.vue?vue&type=template&id=65ef2921&scoped=true&"
import script from "./ProgramTypeIndex.vue?vue&type=script&lang=js&"
export * from "./ProgramTypeIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTypeIndex.vue?vue&type=style&index=0&id=65ef2921&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef2921",
  null
  
)

export default component.exports